var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('textarea',{staticClass:"text-left padding-lr text-df text-black text-400 view padding-top-lg",staticStyle:{"width":"100%","height":"100vh","border-width":"0","background":"transparent","resize":"none"},attrs:{"readonly":""}},[_vm._v("    "+_vm._s(_vm.content+'\n\n')+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793fa6d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/document.vue
// module id = null
// module chunks = 